import { render } from "./PaymentDetails.vue?vue&type=template&id=40dfa062&scoped=true&lang=pug"
import script from "./PaymentDetails.vue?vue&type=script&lang=ts"
export * from "./PaymentDetails.vue?vue&type=script&lang=ts"

import "./PaymentDetails.vue?vue&type=style&index=0&id=40dfa062&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-40dfa062"

export default script